import React, { ComponentProps } from 'react';

interface LogoProps extends ComponentProps<'div'> {
    className?: string;
}

export const Logo: React.FC<LogoProps> = ({ className = "", ...props }) => {
    return (
        <div className={`flex items-center gap-3 ${className}`} {...props}>
            {/* The Tuned Frequency Icon */}
            <span className="h-0.5 w-6 bg-gray-400 relative">
                <span className="absolute top-1/2 left-3 -translate-y-1/2 w-2.5 h-2.5 bg-primary rounded-full shadow-sm ring-2 ring-white/50"></span>
            </span>
            <span className="font-medium text-xl tracking-tight text-main font-sans">
                MoodBoard
            </span>
        </div>
    );
};
